import cryptoMd5 from 'crypto-js/md5'
import hex from 'crypto-js/enc-hex'

const md5 = (data: string): string => cryptoMd5(data).toString(hex)
export default md5
